// EN
export const accomMgmt = {
  common: {
    cancel: "Annulla",
    save: "Salva",
    update: "Aggiorna",
    back: "Indietro",
    continue: "Continua",
    optional: "(facoltativo)",
    optionalPlaceholder: "Facoltativo",
    processing: "Elaborazione in corso...",
    name: "Nome",
    description: "Descrizione",
    nameRequired: "Il nome è obbligatorio.",
  },

  type: {
    apartment: "Appartamento turistico",
    hotel: "Hotel",
    camping: "Campeggio",
    villa: "Villa",
  },

  step: {
    type: "Tipo",
    structure: "Struttura",
    accommodation: "Alloggio",
  },

  step1: {
    title: "Che tipo di alloggio hai?",
    subtitle: "Seleziona il tipo di alloggio.",
    subtitleQuota: "Saranno attivi solo i tipi con quota disponibile nel tuo piano.",
    subtitleFirst: "Trattandosi del tuo primo alloggio, puoi scegliere qualsiasi tipo.",
    remaining: "rimanenti: {count}",
    loadingQuota: "Caricamento della quota del tuo piano…",
  },

  step2: {
    title: "Configura il tuo alloggio",
    subtitle:
      "Decidi se sarà un alloggio singolo o uno con più calendari (diverse unità in un unico alloggio).",
    singleTitle: "Uno spazio singolo",
    singleChip: "1 calendario",
    singleDesc: "Affitta l'intero appartamento con un unico calendario.",
    groupedTitle: "Più spazi",
    groupedChip: "Più calendari",
    groupedDesc: "Affitti diversi spazi indipendenti all'interno dell'appartamento",
  },

  step3: {
    title: "Configura l'alloggio principale",
    subtitle:
      "Sarà il “contenitore” (Listing) che raggruppa più calendari. Es. “Castle Suite”.",
    panelTitle: "Scegli un'opzione",
    availableCount: "Hai {count} alloggi raggruppati disponibili.",
    noneAvailable: "Nessun annuncio raggruppato disponibile per questo tipo (creane uno nuovo).",
    newTitle: "Crea un nuovo alloggio principale",
    newDesc: "Definisci tu il nome dell'alloggio principale.",
    nameLabel: "Nome dell'alloggio principale",
    namePlaceholder: "Es. Castle Suite",
    nameHelp: "Questo nome verrà salvato e potrai raggruppare più calendari.",
    minChars: "Inserisci almeno 3 caratteri.",
    existingTitle: "Aggiungi a un alloggio esistente",
    existingDesc: "L'unità sarà collocata all'interno di un alloggio che hai già creato.",
    selectLabel: "Seleziona l'alloggio",
    selectPlaceholder: "Seleziona un alloggio…",
    listingOption: "{name} · {units} unità",
    ready: "Pronto",
    noneForType: "Non hai alloggi raggruppati disponibili per questo tipo.",
    tip: "Suggerimento: questo “principale” sarà il contenitore a cui verrà aggiunta la nuova unità.",
  },

  preview: {
    tab: "iltuoalloggio",
    perNight: "/notte",
    book: "Prenota",
    locationPlaceholder: "Paese, città, via",
    guests: "{count} ospite | {count} ospiti",
    bedrooms: "{count} camera da letto | {count} camere da letto",
    bathrooms: "{count} bagno | {count} bagni",
    amenitiesTitle: "Servizi",
    amenitiesEmpty: "Seleziona per aggiungere servizi al tuo alloggio",
    locationTitle: "Posizione",
    locationEmpty: "Imposta la posizione",
    descriptionTitle: "Descrizione",
    descriptionEmpty: "Seleziona per aggiungere una descrizione al tuo alloggio",
    namePlaceholder: "Nome dell'alloggio",
    amenity: {
      air_conditioning: "Aria condizionata",
      heating: "Riscaldamento centralizzato",
      parking: "Posto auto",
      oven: "Forno e piano cottura",
      pets_allowed: "Animali ammessi",
      wifi: "Internet WiFi",
      essentials: "Elementi essenziali",
      washing_machine: "Lavatrice",
      children_allowed: "Bambini ammessi",
      refrigerator: "Frigorifero",
    },
  },

  amenities: {
    title: "Dotazioni e comfort",
    subtitle: "Indica agli ospiti cosa offre il tuo alloggio, così sapranno cosa aspettarsi.",
    searchPlaceholder: "Cerca servizio…",
    selectedCount:
      "{count} servizio selezionato | {count} servizi selezionati",
    noResults: 'Nessun servizio trovato per "{search}".',
    cat: {
      all: "Tutti",
      basics: "Elementi essenziali",
      bathroom: "Bagno",
      bedroom: "Camera da letto e lavanderia",
      kitchen: "Cucina e sala da pranzo",
      outdoor: "Esterni",
      leisure: "Svago e intrattenimento",
      safety: "Sicurezza",
      family: "Famiglie",
      parking: "Parcheggio",
      services: "Servizi",
      connectivity: "Connettività",
      accessibility: "Accessibilità",
    },
    item: {
      wifi: "WiFi",
      essentials: "Elementi essenziali",
      air_conditioning: "Aria condizionata",
      heating: "Riscaldamento",
      indoor_fireplace: "Camino interno",
      hot_water: "Acqua calda",
      hangers: "Grucce",
      bed_linen: "Biancheria da letto",
      towels: "Asciugamani",
      shampoo: "Shampoo",
      shower_gel: "Bagnoschiuma",
      conditioner: "Balsamo",
      hair_dryer: "Asciugacapelli",
      bathtub: "Vasca da bagno",
      bidet: "Bidet",
      jacuzzi: "Jacuzzi",
      outdoor_shower: "Doccia esterna",
      washing_machine: "Lavatrice",
      dryer: "Asciugatrice",
      iron: "Ferro da stiro",
      clothes_drying_rack: "Stendibiancheria",
      extra_pillows: "Cuscini e coperte extra",
      wardrobe: "Armadio",
      blackout_curtains: "Tende oscuranti",
      nearby_laundry: "Lavanderia nelle vicinanze",
      oven: "Forno",
      refrigerator: "Frigorifero",
      freezer: "Congelatore",
      microwave: "Microonde",
      dishwasher: "Lavastoviglie",
      cooking_basics: "Utensili da cucina di base",
      plates_cutlery: "Piatti e posate",
      wine_glasses: "Bicchieri da vino",
      coffee_maker: "Macchina del caffè",
      coffee: "Caffè",
      kettle: "Bollitore",
      toaster: "Tostapane",
      blender: "Frullatore",
      rice_cooker: "Cuociriso",
      bread_maker: "Macchina per il pane",
      mini_fridge: "Mini frigo",
      stovetop: "Piano cottura",
      dining_table: "Tavolo da pranzo",
      baking_sheet: "Teglia da forno",
      bbq_grill: "Barbecue",
      bbq_utensils: "Utensili per barbecue",
      outdoor_kitchen: "Cucina esterna",
      outdoor_dining: "Zona pranzo all'aperto",
      breakfast: "Colazione",
      pool: "Piscina",
      shared_pool: "Piscina condivisa",
      garden: "Giardino",
      patio_balcony: "Patio o balcone",
      outdoor_furniture: "Mobili da esterno",
      sun_loungers: "Lettini prendisole",
      hammock: "Amaca",
      fire_pit: "Braciere da esterno",
      shared_fireplace: "Camino in area comune",
      sauna: "Sauna",
      beach_essentials: "Attrezzatura da spiaggia",
      beach_access: "Accesso alla spiaggia",
      lake_access: "Accesso al lago",
      resort_access: "Accesso al resort",
      waterfront: "Affaccio sull'acqua",
      dock: "Molo per barche",
      kayak: "Kayak",
      bikes: "Biciclette",
      ski_slope: "Pista da sci",
      outdoor_playground: "Area giochi all'aperto",
      tv: "TV",
      sound_system: "Impianto audio",
      record_player: "Giradischi",
      piano: "Pianoforte",
      gym: "Palestra",
      exercise_equipment: "Attrezzatura per esercizi",
      games: "Giochi da tavolo",
      giant_games: "Giochi giganti",
      pool_table: "Tavolo da biliardo",
      ping_pong: "Tavolo da ping-pong",
      bowling: "Pista da bowling",
      arcade: "Videogiochi arcade",
      minigolf: "Minigolf",
      batting_cage: "Gabbia di battuta",
      ice_rink: "Pista di hockey su ghiaccio",
      laser_tag: "Laser tag",
      skate_ramp: "Rampa per skate",
      climbing_wall: "Parete da arrampicata",
      game_console: "Console per videogiochi",
      books: "Libri e materiale di lettura",
      cinema: "Cinema",
      themed_room: "Stanza a tema",
      smoke_detector: "Rilevatore di fumo",
      co_detector: "Rilevatore di monossido di carbonio",
      fire_extinguisher: "Estintore",
      first_aid_kit: "Kit di pronto soccorso",
      fire_guard: "Parafuoco",
      safe: "Cassaforte",
      gated_community: "Comunità recintata",
      security_cameras: "Telecamere di sicurezza",
      children_allowed: "Bambini ammessi",
      crib: "Culla",
      travel_cot: "Lettino da viaggio",
      baby_bath: "Vaschetta per il bagnetto",
      baby_safety_gates: "Cancelletti di sicurezza",
      changing_table: "Fasciatoio",
      high_chair: "Seggiolone",
      children_plates: "Piatti e posate per bambini",
      children_books_toys: "Libri e giochi per bambini",
      kids_bikes: "Biciclette per bambini",
      outlet_covers: "Copripresa di sicurezza",
      table_corner_guards: "Paraspigoli per tavoli",
      window_guards: "Protezioni per finestre",
      baby_monitor: "Baby monitor",
      children_game_room: "Sala giochi per bambini",
      babysitter_recommendations: "Consigli su babysitter",
      parking: "Parcheggio gratuito in loco",
      free_street_parking: "Parcheggio gratuito in strada",
      paid_parking_on_premises: "Parcheggio a pagamento in loco",
      paid_parking_off_premises: "Parcheggio a pagamento fuori sede",
      ev_charger: "Colonnina di ricarica per auto elettriche",
      e_bike_charger: "Ricarica per e-bike",
      pets_allowed: "Animali ammessi",
      long_term_stays: "Disponibile per soggiorni lunghi",
      luggage_dropoff: "Deposito bagagli consentito",
      cleaning_during_stay: "Pulizia disponibile durante il soggiorno",
      concierge: "Concierge",
      cleaning_products: "Prodotti per la pulizia",
      recycling: "Contenitori per la raccolta differenziata",
      compactor: "Compattatore di rifiuti",
      compost: "Contenitore per il compost",
      solar_panels: "Pannelli solari",
      workspace: "Spazio di lavoro",
      private_entrance: "Ingresso privato",
      private_lounge: "Salotto privato",
      mosquito_net: "Zanzariera",
      ceiling_fan: "Ventilatore a soffitto",
      portable_fans: "Ventilatori portatili",
      ethernet: "Connessione Ethernet",
      mobile_wifi: "WiFi portatile",
      single_floor: "Alloggio su un unico piano",
      elevator: "Ascensore",
    },
  },

  room: {
    createTitle: "Registra tipo di camera",
    editTitle: "Aggiorna tipo di camera",
    namePlaceholder: "Es. Camera doppia",
    countLabel: "Numero di camere di questo tipo",
    countPlaceholder: "Es. 20",
    countHint: "È l'inventario totale per il tipo. Es. “Doppia” = 20 camere.",
    capacityLabel: "Capacità totale (max ospiti)",
    capacityPlaceholder: "Es. 5",
    capacityHint:
      "È il limite reale di ospiti. Anche se imposti massimi per categoria, prevale il totale.",
    maxAdults: "Max adulti",
    maxChildren: "Max bambini",
    maxInfants: "Max neonati",
    importantLabel: "Importante:",
    capacityNote: "questi sono limiti per categoria. Il totale consentito è definito da “Capacità totale”.",
    physicalTitle: "Camere fisiche (RoomInstances)",
    physicalDesc: "Attivalo se vuoi gestire 101/102, manutenzione e serrature per singola camera.",
    generateLabel: "Genera/Regola le camere fisiche automaticamente",
    generatorTitle: "Generatore di codici",
    prefixLabel: "Prefisso",
    prefixPlaceholder: "Es. 10 o A-",
    prefixHint: "Es. prefisso “10” + inizio 1 => 101,102...",
    startLabel: "Inizio",
    paddingLabel: "Padding",
    paddingHint: "Es. padding 3 => 001,002,003",
    nameModeType: "Solo tipo",
    nameModeTypeCode: "Tipo + codice",
    defaultDescLabel: "Descrizione predefinita",
    willCreatePre: "Fino a",
    willCreatePost: "camere fisiche verranno create o regolate automaticamente.",
    errors: {
      saveFallback: "Errore durante il salvataggio del tipo di camera.",
      capacityMin: "La capacità totale deve essere almeno 1.",
      adultsMin: "Deve essere consentito almeno 1 adulto.",
      adultsMax: "Il limite di adulti non può superare la capacità totale.",
      childrenRange: "Il limite di bambini deve essere compreso tra 0 e la capacità totale.",
      infantsRange: "Il limite di neonati deve essere compreso tra 0 e la capacità totale.",
      roomsMin: "Il numero di camere deve essere almeno 1.",
      notAuth: "Utente non autenticato.",
    },
    toasts: {
      updated: "Tipo aggiornato.",
      created: "Tipo creato.",
      roomsSynced: "Camere fisiche generate/regolate con successo.",
    },
  },

  rate: {
    registerHeader: "Registra tipo di camera",
    editHeader: "Aggiorna tariffa - {name}",
    createHeader: "Registra tariffa - {name}",
    processing: "Elaborazione in corso, attendi.",
    general: "Generale",
    namePlaceholder: "Nome personalizzato",
    validityLabel: "Periodo di validità",
    permanent: "Permanente",
    custom: "Personalizzato",
    startDatePlaceholder: "Data di inizio",
    endDatePlaceholder: "Data di fine",
    validityNoteCustom: "Periodo di validità della tariffa (facoltativo)",
    validityNotePermanent: "Tariffa valida in modo permanente",
    pricePerNight: "Prezzo a notte",
    taxIncluded: "Tasse incluse",
    occupancy: "Occupazione",
    guestsNumber: "Numero di ospiti",
    minStay: "Soggiorno minimo",
    minStayNote: "Notti minime da fatturare",
    maxStay: "Soggiorno massimo",
    maxStayNote: "Limite di notti prenotabili",
    errors: {
      rangeRequired: "Devi selezionare un intervallo di date valido",
      startAfterEnd: "La data di inizio non può essere successiva alla data di fine",
      minStay:
        "Il soggiorno minimo è di {minStay} notti, ma l'intervallo selezionato ha {nights} notti",
    },
  },
};
